import React from 'react';
import { Perk } from '@plans/tiles';
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Micro } from '@vds/typography';
import { InHomeUtils } from '../../util/inhomeUtils';
import ReactHtmlParser from 'react-html-parser';
import { Button, TextLink } from '@vds/buttons';
import { useMobileView } from '../../hooks/useMobileView';
import * as modalAction from './../../action/modalWindow';
import { Tooltip } from '@vds/tooltips';
import { updateSCTags } from '../../service/dtmTag';
import { updateVzdlSCCustomEvent } from '../../service/vzdl';


const DiscountFlowModal = props => {

  const { buildProduct, closeModal, lqState,type } = props;
  const isDiscountFlow = lqState.MFRTEligible && InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow && InHomeUtils.isNotNull(lqState.SweetnerMsgMFRT) && InHomeUtils.isNotNull(lqState.SweetnerMsgMFRT.discountEligible) && lqState.SweetnerMsgMFRT.discountEligible;

  // function findSplOffer(plans, keyToFind, valToFind) {
  //   if (Array.isArray(plans)) {
  //     plans?.forEach(p => {
  //       if (Array.isArray(p?.specialOffers)) {
  //         return p?.specialOffers?.find(o => o?.[keyToFind] === valToFind);
  //       }
  //     });
  //   }
  //   return undefined;
  // }

  let findMlForm5 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37480") > -1)
  let findMlForm10 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37481") > -1)
  let findMlForm15 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37482") > -1)

  let maxMilitaryOfferPriceVal =""
  if(findMlForm15 ){
    maxMilitaryOfferPriceVal = "$15"
  } else if(findMlForm10 ){
    maxMilitaryOfferPriceVal = "$10"
  } else if(findMlForm5){
    maxMilitaryOfferPriceVal = "$5"
  }
  
  console.log('maxPrice value Military ', maxMilitaryOfferPriceVal)

  let findForrs5 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37483") > -1)
  let findForrs10 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37484") > -1)
  let findForrs15 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37485") > -1)
  
  let maxRespondOfferPriceVal =""
  if(findForrs15){
    maxRespondOfferPriceVal = "$15"
  } else if(findForrs10){
    maxRespondOfferPriceVal = "$10"
  } else if(findForrs5){
    maxRespondOfferPriceVal = "$5"
  }
  console.log('maxPrice value Response ', maxRespondOfferPriceVal)

  /** nurse */ 
  let findFornurse5 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37489") > -1)
  let findFornurse10 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37490") > -1)
  let findFornurse15 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37491") > -1)
  
  let maxNurseOfferPriceVal =""
  if(findFornurse15){
    maxNurseOfferPriceVal = "$15"
  } else if(findFornurse10){
    maxNurseOfferPriceVal = "$10"
  } else if(findFornurse5){
    maxNurseOfferPriceVal = "$5"
  }
  console.log('maxPrice value nurse ', maxNurseOfferPriceVal)

  /** Teachers  */
  
  let findFor5 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37486") > - 1);
  let findFor10 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37487") > -1 );
  let findFor15 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "37488") > -1);
  
  let maxTWSOfferPriceVal =""
  if(findFor15 ){
    maxTWSOfferPriceVal = "$15"
  } else if(findFor10 ){
    maxTWSOfferPriceVal = "$10"
  } else if(findFor5){
    maxTWSOfferPriceVal = "$5"
  }
  console.log('maxPrice value TWS', maxTWSOfferPriceVal)


  let findForSt5 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "38729") > - 1);
  let findForSt10 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "38730") > -1 );
  let findForSt15 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => o?.OfferId === "38731") > -1);
  
  let maxStudentOfferPriceVal =""
  if(findForSt15){
    maxStudentOfferPriceVal = "$15"
  } else if(findForSt10){
    maxStudentOfferPriceVal = "$10"
  } else if(findForSt5 ){
    maxStudentOfferPriceVal = "$5"
  }

  console.log('maxPrice value Student', maxStudentOfferPriceVal)
  let twsdiscountpricename = buildProduct?.internet?.m2mPlans[buildProduct?.internet?.m2mPlans.length - 1]?.specialOffers[buildProduct?.internet?.m2mPlans[buildProduct?.internet?.m2mPlans.length - 1]?.specialOffers.length - 1]?.OfferText;
  console.log('offerName', twsdiscountpricename);

  let text ="$5 Teachers Fios Home Internet Discount";
  let twsdiscountprice = text?.replace(/(.*)(\s.*)/, '$1');
  twsdiscountprice = twsdiscountprice?.slice(0,2);
  const isMnh = buildProduct.internet.mnhSignupIndicator === "Y";

  const DEALS_AT_WORK_5 = ["R1345", "R1346", "Q7736", "O6327", "H4711", "Q7740"];
  const DEALS_AT_WORK_10 = ["R1347", "H6610"];
  const findForDaw5 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => DEALS_AT_WORK_5.includes(o?.id)) > -1);
  const findForDaw10 = buildProduct?.internet?.m2mPlans?.some(p => p?.specialOffers?.findIndex(o => DEALS_AT_WORK_10.includes(o?.id)) > -1);
  const hasDealsAtWorkDiscount = findForDaw5 || findForDaw10;
  let maxDealsAtWorkDiscount = 0;
  if (findForDaw10) {
    maxDealsAtWorkDiscount = 10;
  } else if (findForDaw5) {
    maxDealsAtWorkDiscount = 5;
  }

  const isMax2GigPlan = buildProduct?.internet?.m2mPlans?.find?.(item => (item?.id === "R3582" || item?.name?.toUpperCase?.()?.includes?.("2 GIG")));
  const isMaxGigabitPlan = buildProduct?.internet?.m2mPlans?.find?.(item => !isMax2GigPlan && item?.name?.toUpperCase?.()?.includes?.("GIGABIT CONNECTION"));
  const isMax1GigPlan = buildProduct?.internet?.m2mPlans?.find?.(item => !isMax2GigPlan && (item?.id === "R3583" || (item?.name?.toUpperCase?.()?.includes?.("GIG"))));
  const isMax500Plan = buildProduct?.internet?.m2mPlans?.find?.(item => !isMax2GigPlan && !isMax1GigPlan && item?.name?.toUpperCase?.()?.includes?.("500"));
  let planName = isMax2GigPlan
    ? "1 Gig/2 Gig"
    : isMaxGigabitPlan
      ? isMaxGigabitPlan?.name || "Gigabit Connection"
      : isMax1GigPlan
        ? isMax1GigPlan?.name || "1 Gig"
        : isMax500Plan
          ? isMax500Plan?.name || "500 Mbps"
          : "";
  planName = planName?.replace?.("4.0", "")?.trim?.();
  const hasPerkCredit = buildProduct?.internet?.m2mPlans?.some?.(p => p?.specialOffers?.some?.(o => o?.OfferText?.toUpperCase?.()?.includes?.("HOME PERK CREDIT")));

  const getVZFwdContent = () => {
    return <>
      <ModalTitle>
      These discounts and credits will be applied to your monthly bill.
      </ModalTitle>
      <div style={{marginTop: "20px"}}>
      <ModalBody>
        <Body size='medium'>
          <b>{`Verizon Forward${buildProduct?.isVzfNYDiscount ? ' - NY ' : ''} Discount`}</b><p style={{marginBottom: '8px'}}>{`Up to $${buildProduct?.isVzfNYDiscount ? '40' : '30'}, discount adjusted based on the internet plan price and any other existing discounts on your account.`}</p>
          <small style={{ color: '#6F7171', fontSize: '11px'}}>{buildProduct?.isVzfNYDiscount ? 'Verizon Forward-NY Broadband discount is only available to eligible customers within the state of New York and who complete the approval process; discount applied within 1-2 billing cycles after requirements are met. May not combine with all offers. One discount per eligible account. Fios Mix and Match available in selected areas. Learn more at verizon.com/verizonforward-ny.' : 'Verizon Forward credit: Offer ends 12.31.24. Availability varies. For new eligible residential customers who are qualified for Verizon Forward and sign up for 5G Home, LTE Home or Fios 300 Mbps internet. Subject to credit approval.'}</small>            
        </Body>
        {
          buildProduct?.isVZFCreditFlag && <>
            <Body size='medium'>
              <p style={{marginBottom: '8px', marginTop: '8px'}}><b>Verizon Forward Credit</b><br />Get service for as low as $0/mo for 6 months with the Verizon Forward Credit.</p>
              <small style={{ color: '#6F7171', fontSize: '11px'}}>Promo credit ends if eligibility requirements are no longer met. After 6 months, you will be charged the then-current price. Must install/activate eligible service by 9.30.24.</small>
            </Body>
          </>
        }
        <Body size='medium'>
          <p style={{ marginTop: '8px' }}><b>Auto Pay and paper-Free Billing</b><br/>When you enroll in Auto Pay and paper-free billing using your bank account or the Verizon Visa Card, you qualify for a $10/mo discount. Enrollment in Auto Pay and paper-free billing during checkout required for the discount.</p>
        </Body>
        {
          (buildProduct?.internet?.mnhSignupIndicator === "Y" && !(buildProduct?.emberInfo?.isMF4DISC15 && hasPerkCredit)) && <>
            <b>Mobile + Home Discount</b><p style={{marginBottom: '8px'}}>Save up to $15/mo. when you bundle your Home internet service with a postpaid mobile unlimited plan.</p>
          </>
        }
        {(buildProduct?.internet?.mnhSignupIndicator === "Y" && (buildProduct?.emberInfo?.isMF4DISC15 && hasPerkCredit)) && (
          <>
            <b>Mobile + Home Discount</b><br/>
            <p>Save $15/mo when combined with postpaid mobile plan. Also get up to $10/mo towards an eligible perk, like Disney+, Hulu, ESPN+ (With Ads) or Youtube Premium, when you add and maintain a {planName} plan.</p>
            <p className="perktextcolour">Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.</p>
          </>
        )}
      </ModalBody>      
      </div>      
    </>
  };

  const getDiscountsContent = () => {
    console.log('type of tws discount', type,  buildProduct.internet?.typeofDiscount?.toLowerCase())
    let typeOfDiscount = buildProduct.internet?.typeofDiscount?.toLowerCase();
    let mfrtTypeVal = lqState?.mfrtType && typeof lqState.mfrtType === 'string' && lqState.mfrtType?.toLowerCase() ? lqState.mfrtType?.toLowerCase() : '';
    return <>
      <ModalTitle>
        Save on your home internet plan with these discounts.
      </ModalTitle>
      <ModalBody > 
        { (mfrtTypeVal === 'military' || type === 'military' || typeOfDiscount === 'military') && maxMilitaryOfferPriceVal?.length > 0 &&
        <Body size='medium'>
          <b>Military & Veterans Discount</b><br/>Save up to {maxMilitaryOfferPriceVal}/mo discount adjusted based on the internet plan price.
        </Body>
        }
        { (mfrtTypeVal === 'responder' || type === 'responder' || typeOfDiscount === 'firstresponders') && maxRespondOfferPriceVal?.length > 0 &&
        <Body size='medium'>
          <b>First responders Discount</b><br/>Save up to {maxRespondOfferPriceVal}/mo discount adjusted based on the internet plan price.
        </Body>
        }
        { (mfrtTypeVal === 'nurse' || type === 'nurse' || type === 'medical' || typeOfDiscount === 'nurse' || typeOfDiscount === 'medical') && maxNurseOfferPriceVal?.length > 0 &&
        <Body size='medium'>
          <b>Nurses Discount</b><br/>Save up to {maxNurseOfferPriceVal}/mo discount adjusted based on the internet plan price.
        </Body>
        }
        { (mfrtTypeVal === 'student' || type === 'student' || typeOfDiscount === 'student') && maxStudentOfferPriceVal?.length > 0 &&
        <Body size='medium'>
          <b>Student Discount</b><br/>Save up to {maxStudentOfferPriceVal}/mo discount adjusted based on the internet plan price.
        </Body>
        }
        { (mfrtTypeVal === 'teacher' || type === 'teacher' || typeOfDiscount === 'teachers') && maxTWSOfferPriceVal?.length > 0 &&
        <Body size='medium'>
          <b>Teachers Discount</b><br/>Save up to {maxTWSOfferPriceVal}/mo discount adjusted based on the internet plan price.
        </Body>
        }
        {(hasDealsAtWorkDiscount && maxDealsAtWorkDiscount > 0) && (
          <p>
            <b>Deals at work Discount</b><br/>
            Save up to ${maxDealsAtWorkDiscount}/mo, discount adjusted based on the internet plan price.
          </p>
        )}
        {
          (buildProduct?.internet?.mnhSignupIndicator === "Y" && !(buildProduct?.emberInfo?.isMF4DISC15 && hasPerkCredit)) && <>
            <b>Mobile + Home Discount</b><p style={{marginBottom: '8px'}}>Save up to $15/mo. when you bundle your Home internet service with a postpaid mobile unlimited plan.</p>
          </>
        }
        {(buildProduct?.internet?.mnhSignupIndicator === "Y" && (buildProduct?.emberInfo?.isMF4DISC15 && hasPerkCredit)) && (
          <>
            <b>Mobile + Home Discount</b><br/>
            <p>Save $15/mo when combined with postpaid mobile plan. Also get up to $10/mo towards an eligible perk, like Disney+, Hulu, ESPN+ (With Ads) or Youtube Premium, when you add and maintain a {planName} plan.</p>
            <p className="perktextcolour">Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.</p>
          </>
        )}
      </ModalBody>
    </>
  };
  const onCloseModal = (isModalOpened) => {
    if(!isModalOpened){
      closeModal();
    }
  }

  return (
    <Modal opened={true} onOpenedChange = {(isModalOpened) => {onCloseModal(isModalOpened)}}>
      {
        console.log(buildProduct.internet?.typeofDiscount?.toLowerCase(),'tws discount type')
      }
      {
        buildProduct?.isVZFwdFlag ? getVZFwdContent() : <></>
      }
      {
       type === 'military' || type === 'responder'|| type === 'nurse' || type === 'medical' || type === 'teacher' || type === 'student' || isDiscountFlow || buildProduct.internet?.typeofDiscount?.toLowerCase() === 'military' || buildProduct.internet?.typeofDiscount?.toLowerCase() === 'firstresponders'|| buildProduct.internet?.typeofDiscount?.toLowerCase() === 'nurse' || buildProduct.internet?.typeofDiscount?.toLowerCase() === 'medical' || buildProduct.internet?.typeofDiscount?.toLowerCase() === 'teachers' || buildProduct.internet?.typeofDiscount?.toLowerCase() === 'teacher' || buildProduct.internet?.typeofDiscount?.toLowerCase() === 'student' || lqState?.couponFlowType?.toUpperCase?.() === "AFFINITY"
        ? getDiscountsContent()
        : <></>
      }
      {buildProduct?.isVZFwdFlag ?
        <ModalFooter>
          <Button onClick={closeModal}>Got it</Button>
        </ModalFooter>
        :
        <ModalFooter
          buttonData={{
            primary: {
              children: "Got it",
              width: 'auto',
              onClick: () => {
                document.getElementById('close-button').click();
              }
            }
          }}
        />
      }
    </Modal>
  )
}

const perkDisclaimers = (id) => {
  const disclaimers = {
    // Netflix & Max
    R3559: `<p>Netflix & Max (With Ads) perk requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 years of age or older to enroll.Cancel anytime After enrolling in the Netflix & Max (With Ads) perk, you will need to complete account setup separately for each service. Access content from each service separately. Netflix and Max may be upgraded and downgraded directly via those two services. Enrolling in the Netflix & Max (With Ads) perk may affect existing subscriptions to Netflix and Max. After enrolling, you must register your Perk to avoid multiple subscriptions and corresponding charges. $6.98/mo perk savings based on the current $6.99/mo for Netflix Standard with Ads and $9.99/mo for Max (With Ads plan) less $10/mo perk added to Verizon Home Internet. One offer per eligible VHI account. Subject to <a href="https://help.netflix.com/legal/termsofuse" target="_blank">Netflix Terms of Use</a> and <a href="https://www.max.com/terms-of-use/en-us" target="_blank">Max Terms of Use</a>. Max is used under license.</p>`,
     // Disney Bundle
    R3558: `<p>The Disney Bundle from Verizon includes Disney+ (No Ads), Hulu (With Ads), and ESPN+ (With Ads). Access content from each service separately. The Disney Bundle requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account.</p><p>FOR EXISTING DISNEY+, HULU OR ESPN+ subscribers: Offer will not automatically replace existing subscription(s). After enrolling in this promotional offer, you will need to complete account setup separately for each service. Managing subscriptions may be required to avoid multiple subscriptions and corresponding charges. For existing Hulu subscribers, you may need to manage your subscription to complete account setup.</p><p>$6.99/mo perk savings based on the current $21.99/mo that Verizon Disney Bundle Subscribers pay for the bundle less the $15/mo Disney perk added to VHI plan. Add'l terms apply. © 2024 Disney and its related entities.</p>`,
    //Disney trio grandfather
    R4438:  `<p>Disney+, Hulu, ESPN+ (With Ads) from Verizon includes Disney+(With Ads), Hulu(With Ads), and ESPN+(With Ads). Access content from each service separately. Disney+, Hulu, ESPN+ (With Ads) requires an eligible Verizon Home Internet(“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account.<br/>FOR EXISTING Disney+, Hulu, ESPN+ (With Ads) subscribers: Offer will not automatically replace existing subscription(s). After enrolling in this promotional offer, you will need to complete account setup separately for each service. Managing subscriptions may be required to avoid multiple subscriptions and corresponding changes. For existing Hulu subscribers, you may need to manage your subscription to complete account setup. <br/>$6.99/mo perk savings based on the current $16.99/mo that Verizon Disney+, Hulu, ESPN+ (With Ads) pay </p>`,
     // Apple One
    R3556: `<p>Apple One requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account. Add’l terms apply.</p>`,
    // Apple One Family
    R3557: `<p>Apple One Family requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account. Add’l terms apply.</p>`,
    // Walmart
    R3554: `<p>Walmart+ Membership requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account. Add’l terms apply.</p>`,
    // Apple Music
    R3555: `<p>Apple Music Family requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account. Perk savings based on the current retail value of monthly subscriptions less the $10/mo. perk added to VHI plan.  Add’l terms apply.</p>`,
    // Youtube Premium
    R3680: `<p>YouTube Premium perk requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 years of age or older to enroll. After enrolling in the YouTube Premium perk, you will need to complete account setup to use the service. Enrolling in the YouTube Premium perk may affect existing subscriptions to YouTube Premium. Managing subscriptions may be required to avoid multiple subscriptions and corresponding charges. One offer per eligible VHI account. Subject to <a href="https://www.youtube.com/t/terms" target="_blank">YouTube Terms of Service</a> & <a href="https://www.youtube.com/premium/restrictions" target="_blank">YouTube Premium and Music Premium Terms of Use</a></p>`,
    // +play
    R3551: `<p>[+] play Monthly Credit requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Credit must be used within one month. Cancel anytime.  +play Monthly Credit can only be applied on select +play services, see full list at <a href="https://www.verizon.com/support/entertainment-play-perk-faqs/" target="_blank">https://www.verizon.com/support/entertainment-play-perk-faqs/</a>. One offer per eligible VHI account. Add’l terms apply. $5/mo. savings based on the $15/mo. +play credit that can be used for purchases in +play less the $10/mo. +play Monthly credit perk added to the VHI plan.</p>`, 
    // Unlimited cloud storage
    R3552: `<p>Unlimited Individual Cloud Storage requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account. Add’l terms apply. Verizon Cloud does not backup operating systems, settings, apps, emails, external drives and uncommon file types. Backup varies by operating platform. See <a href="https://www.verizon.com/support/verizon-cloud-faqs/">www.verizon.com/support/verizon-cloud-faqs</a> for service limitations.</p>`, 
    // Unlimited cloud group
    R3553: `<p>Unlimited Group Cloud Storage requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 yrs or older. Cancel anytime. One offer per eligible VHI account. Add’l terms apply. Verizon Cloud does not backup operating systems, settings, apps, emails, external drives and uncommon file types. Backup varies by operating platform. See <a href="https://www.verizon.com/support/verizon-cloud-faqs/" target="_blank">www.verizon.com/support/verizon-cloud-faqs</a> for service limitations.</p>`, 
    // Verizon Home Advisor
    R3731: `<p>Limitations and exclusions apply for in-home visits. See Terms and Conditions for details.  Optional product installations available in select locations, which are subject to change at any time.  Products must be new or fully functioning at the time of installations ands Wi-Fi access must be available for certain products to be installed.  Availability of installation services is contingent on certain criteria including product type, customer location and appointment/technician availability.</p>`,
    //Google One AI Premium 

    R4224 :`<p>Google One AI Premium perk requires an eligible Verizon Home Internet (“VHI”) plan. Must be 18 years of age or older to enroll. After enrolling in the Google One AI Premium perk, you will need to activate your Google One AI Premium membership to use the service. Activating in the Google One AI Premium perk may affect existing subscriptions to Google One AI Premium. To activate your Google One AI Premium membership obtained through the Google One AI Premium perk you’ll need to cancel any existing subscription you have to Google One. Subject to <a href="https://one.google.com/terms-of-service?hl=en_ZA&g1_landing_page=0" target="_blank">Google One Terms of Service.</a></p>`

  }
  return disclaimers[id];
};

const getDisneyPromoContent = selectedSpeed => {
  return `Disney Bundle incl. Disney+ (No Ads), Hulu (With Ads), and ESPN+ (With Ads). Enrollment in the Disney Bundle perk for 12 mos on us promo requires a ${selectedSpeed} plan; must install ${selectedSpeed} service and enroll in perk w/in 60 days after plan purchase, or by no later than 1.6.25, whichever is first, and then register the perk directly with Disney w/in 90 days of enrollment. $10/mo perk credit ends after 12 mos or if perk is canceled or VHI plan is moved to an ineligible plan during the 12 mo promo period. After 12 mos, perk bills as $10/mo unless perk is canceled. That’s an $11.99/mo perk savings - based on the current $21.99/mo that Verizon Disney Bundle Subscribers pay for the bundle less the $10/mo Disney Bundle perk when that perk is added to myHome. Must be 18 yrs or older. One offer per eligible VHI plan. Add’l terms apply. Limited-time offer. EXISTING DISNEY+, HULU OR ESPN+ SUBSCRIBERS: Perk will not automatically replace existing subscription(s). Managing subscriptions may be required to avoid multiple subscriptions and corresponding charges. Terms apply. © 2024 Disney and its related entities.`;
}

const getNetflixPriceUp = (id) => {
  const disclaimers = {
    // Netflix & Max
    R3559: `<p>Netflix & Max (With Ads) perk requires line subscribed to an eligible Verizon Home Internet (“VHI”) plan. Must be 18 years of age or older to enroll. After enrolling in the Netflix & Max (With Ads) perk, you will need to complete account setup separately for each service. Access content from each service separately. Netflix and Max may be upgraded and downgraded directly via those two services.</p><p>Enrolling in the Netflix & Max (With Ads) perk may affect existing subscriptions to Netflix and Max. After enrolling, you must register your Perk to avoid multiple subscriptions and corresponding charges. $7.98/mo perk savings based on the current $7.99/mo for Netflix Standard with Ads and $9.99/mo for Max Basic (With Ads plan) less $10/mo perk added to Verizon Home Internet plan. One offer per eligible VHI account. Subject to <a href="https://help.netflix.com/legal/termsofuse" target="_blank">Netflix Terms of Use</a> and <a href="https://www.max.com/terms-of-use/en-us" target="_blank">Max Terms of Use</a>. Max and related elements are property of Home Box Office, Inc.</p>`,
  }
  return disclaimers[id];
}

export const PerksTnC = props => {

  const { perks, buildProduct ,lqState ,cart } = props;
  const selectedSpeed = buildProduct?.internet?.selectedProduct?.description || '';
  return <Modal toggleButton={<TextLink surface="light">Terms & Conditions.</TextLink>} >
      <ModalTitle>
        Perk terms & conditions
      </ModalTitle>
      <ModalBody>
        {
          perks?.map(perk => {
            let OCOCheck = cart?.cartData?.[0]?.perks?.perks?.filter((key)=>!key?.keyword?.includes?.("OCO:YES") && key?.prodId == perk?.prodId);
            const perkMrp = (perk?.keyword || perk?.productKeyword)?.split('MRP:')?.[1];
             let perkActPrice = perkMrp?.split('|')?.[0]; 
             if(OCOCheck?.length > 0){
            return <Body size='medium' style={{ marginBottom: '12px' }}>
              <b>{perk.prodName === "Verizon Home Device Protect" || perk.prodId === 'R3784' ? '' : perk.prodName }</b><br/>
              {
                perk.prodId === 'R3558' && buildProduct?.isDisneyPromoPresent 
                ? ReactHtmlParser(getDisneyPromoContent(selectedSpeed))
                : perk.prodId === 'R3559' && perkActPrice !== '16.98' ?  ReactHtmlParser(getNetflixPriceUp(perk.prodId)) :  ReactHtmlParser(perkDisclaimers(perk.prodId))
              }
            </Body>
             }
          })
        }
      </ModalBody>
      <ModalFooter buttonData={{
      primary: {
        width: 'auto',
        children: 'Got it',
        onClick: () => {
          document?.getElementById('close-button').click()
        }
      }
    }}/>
    </Modal>
};

export const VZMobileBanner = props => {
  const { closeBanner, buildProduct, modalWindow, dispatch, signinClicked} = props;
  const is2GigPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => item?.id === "R3582" || item?.name?.toUpperCase?.()?.includes?.("2 GIG")) > -1;
  const is1GigPlan = buildProduct?.internet?.m2mPlans?.findIndex?.(item => item?.id === "R3583" || (!is2GigPlan && item?.name?.toUpperCase?.()?.includes?.("GIG"))) > -1;
console.log('DEBUG VZMOBILEBANNER', props);
const isMobileView = useMobileView();
const handleCrossIcon=(isOpen)=>{
  if(!isOpen){
    updateSCTags("close sign")
    closeBanner()
  }
}
updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail", false, "", false, "", "", "", "Mobile + Home overlay");

  const invokeScript = () => {
    console.log('DEBUG: invokeScript')
    try {
      const igtransactionID  = buildProduct?.mnhTokenGenerationResponse?.transactionID;
      let transactionIDStartsWith = igtransactionID?.substring(0,2);
      let igScriptURL = 'https://scache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
      if(lqState?.runtimeKey?.isNewAAURLFlowEnabled === 'Y'){
        if ((window.location.host === 'www.verizon.com' || window.location.host === 'preprod-east-gz.vpc.verizon.com' || window.location.host === 'espanol.verizon.com')) {
          if(transactionIDStartsWith == 'W-'){
              igScriptURL = 'https://scache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
          } else if(transactionIDStartsWith == 'N-'){
              igScriptURL = 'https://scache-ws.vzw.com/am/aa/nsa/assets/js/vzigaaplugin.min.js';
          }
        } else {
          if(transactionIDStartsWith == 'W-'){
            igScriptURL = 'https://stcache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
          } else if(transactionIDStartsWith == 'N-'){
            igScriptURL = 'https://stcache-ws.vzw.com/am/aa/nsa/assets/js/vzigaaplugin.min.js';
          }
        }
      } else {
        if ((window.location.host === 'www.verizon.com' || window.location.host === 'preprod-east-gz.vpc.verizon.com' || window.location.host === 'espanol.verizon.com')) {
          igScriptURL = 'https://scache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
        } else {
          igScriptURL = 'https://stcache-ws.vzw.com/am/aa/aa/assets/js/vzigaaplugin.min.js';
        }
      }
      
       
      const fileref = document.createElement('script');
      fileref.setAttribute('async', true);
      fileref.setAttribute('defer', 'defer');
      fileref.setAttribute('src', igScriptURL);
      document.getElementsByTagName('head')[0].appendChild(fileref);
    } catch (e) {
      console.log('Error in Retry vzigaaplugin Script call');
    }
  }
  const signInClick = (e)=>{
   
    signinClicked(e);
    // invokeScript();
    closeBanner();
    modalAction.openModalWindow("mnhSignIn", dispatch);
    
    // tempVzdlSCData.detail = 'Already Have Verizon Wireless';
    // updateVzdlSCCustomEvent("buildFiosInit", "pageViewOmni", "detail");
}
  const handlePrimaryClick = (e) => {
    try {
      updateSCTags("Sign In")
      signInClick(e);
      
    } catch (e) {
      console.error(e);
    }
  }

  document.addEventListener('keydown', (event) => {
    if (event.keyCode === 27) {
      closeBanner();
    }
  })

  return <Modal opened={true} 
      id={buildProduct?.internet?.mnhSignupIndicator === "Y" ? "mnTooltipBannerAuth_Modal" : "mnTooltipBanner-Modal"}
      onOpenedChange={(isOpen)=>handleCrossIcon(isOpen)} 
      >    
    <ModalTitle>
      Mobile + Home discount
    </ModalTitle>
    <ModalBody>
      <Body size='medium'>
        {buildProduct?.emberInfo?.isEmberFlow ? (
          <>
            <p style={{ marginBottom: 20, marginTop: 20, fontSize: "1rem" }}>Save $15/mo when on any postpaid mobile plan. {(is2GigPlan ? "1 Gig or 2 Gig" : is1GigPlan ? "1 Gig" : "500 Mbps")} customers also get a $10/mo credit on any eligible perk. Mobile + Home discount enrollment req'd.</p>
            <p style={{ marginBottom: 20, marginTop: 20, fontSize: "0.75rem", color: "#6F7171" }}>$10/mo credit applied to active eligible full price perk on either wireless or home service bill.</p>
          </>
        ) : (
          buildProduct?.internet?.mnhSignupIndicator !== "Y" ? <p style={{ marginBottom: 20, marginTop: 20 }}>Save up to $15/mo for existing Verizon postpaid mobile customers who add and maintain a Fios Internet plan. Mobile + Home discount enrollment req'd.</p> :
            <p style={{ marginBottom: 20, marginTop: 20 }}>Add Fios Internet and save up to $15/mo for existing Verizon postpaid mobile customers. Mobile + Home discount enrollment req'd.</p>
        )}
      </Body>
    </ModalBody>
    <div className="appfbFormAlign">
      {buildProduct?.internet?.mnhSignupIndicator !== "Y" && <div className="tiny-12 small-3 margin-right-tiny">
        <Button use="primary" width="100%" onClick={handlePrimaryClick}>Sign in </Button>
      </div>}
      <div className={`tiny-12 small-3 ${isMobileView ? "margin-top-tiny" : ""}`}>
        <Button use={buildProduct?.internet?.mnhSignupIndicator !== "Y" ? "secondary" : "primary"} width="100%" onClick={() => { updateSCTags("Close"); closeBanner(); }}>{buildProduct?.internet?.mnhSignupIndicator !== "Y" ? "Close" : isMobileView ? "Got it" : "Close"}</Button>
      </div>
    </div> 
  </Modal>
};

export const PerkAddlInfo = props => {
  const { closeModal, conflictMessage,  perkMessages, id } = props;
  const isMobileView = useMobileView();

  return <Modal opened={true} id="perkAddlInfo">
    <ModalTitle>Information for current Disney+,Hulu,ESPN+ (With Ads) Subscribers</ModalTitle>
    <ModalBody>
      <Body size='medium'>
        If you already have an email associated with a Disney+, Hulu, ESPN+ (With Ads) subscription, you may use that email to register for the Disney+, Hulu, ESPN+ (With Ads) to maintain your profile & settings, but note that your new subscription will not automatically replace existing Disney+, Hulu, ESPN+ (With Ads) subscriptions. Managing subscriptions may be required. Terms apply.
      </Body>
    </ModalBody>
    <ModalFooter
      buttonData={{    
          primary: {
            children: "Got it",
            width: isMobileView ? '100%' : 'auto',
            onClick: () => {
              document.getElementById('close-button').click();
              closeModal(false);
              // if(perkMessages && perkMessages.find((list) => list.msgId.includes('WIRELESS') && list.applicablePerks === id)){
              //   conflictMessage(true);
              // }
            }
          }
      }}
    />
  </Modal>
};

export const YouTubeBannerDetails = props => {
  const { isBanner, product } = props;

  return <Modal toggleButton={isBanner ? <TextLink ariaLabel="Details New YouTube TV subscribers save $120 first year" surface="light" role="button">Details</TextLink> : <button type="button"  style={{ cursor: "pointer", padding: "0", verticalAlign: "middle" }}>
      <Tooltip disabled={true} size="small" surface="dark" />
    </button>}>
    <ModalTitle>New Youtube TV subscribers save $10/mo for 12 months.</ModalTitle>
    <ModalBody>
      Offer available to Verizon Home Internet customers who are not a current or prior YouTube TV subscriber or trial user previously. Must activate YouTube TV subscription through YouTube TV w/in 90 days of new home internet activation/installation or when added to an existing internet plan. $10/month discount for 12 months on the standard subscription price, currently <span>{product?.displayPrice}/mo</span>. (subject to change); discount ends if home internet service is canceled (subscription will continue to be billed at the standard subscription price unless you cancel with YouTube TV by going to your YouTube TV settings). At the end of 12-month period you will be automatically charged the then-current standard subscription price monthly until you cancel. Must be 18 years or older. Valid form of payment required. Redeemable where YouTube TV is available. Full terms here: <a href="https://www.youtube.com/t/terms_paidservice" target="_blank">www.youtube.com/t/terms_paidservice</a>. Promotional value of subscription(s) are non-transferable, not for resale and not redeemable for cash. Offer available in markets where YouTube TV service is available.
    </ModalBody>
    <ModalFooter buttonData={{    
          primary: {
            children: "Got it",
            onClick: () => {
              document.getElementById('close-button').click();
            }
          }
      }}
    />
  </Modal>
};

export const getDisneyPromoDts = (viewport = '') => {
  const isMobileView = viewport ? (viewport === 'mobile') : useMobileView();
  return <Modal toggleButton={<TextLink surface="light" type='inline' size='small'>Details</TextLink>}
  id={`${isMobileView ? 'mnTile_reviewModal_mobile' : 'mnTile_reviewModal'}`}>
    <ModalTitle>
      Get 12 months of Disney Bundle, on us with the [1 Gig/2 Gig] plan.
    </ModalTitle>
    <ModalBody>
      <Body size='medium'>
        To receive this perk for 12 months on us, select Disney Bundle. Then, register your subscription on the Disney site.
      </Body>
      <Body size='small' primitive='span'>
        Disney Bundle incl. Disney+ (No Ads), Hulu (With Ads), and ESPN+ (With Ads). Enrollment in the Disney Bundle perk for 12 mos on us promo requires a Fios 1 Gig plan; must install Fios 1 Gig service and enroll in perk w/in 60 days after plan purchase, or by no later than 1.6.25, whichever is first, and then register the perk directly with Disney w/in 90 days of enrollment. $10/mo perk credit ends after 12 mos or if perk is canceled or VHI plan is moved to an ineligible plan during the 12 mo promo period. After 12 mos, perk bills as $10/mo unless perk is canceled. That’s an $11.99/mo perk savings - based on the current $21.99/mo that Verizon Disney Bundle Subscribers pay for the bundle less the $10/mo Disney Bundle perk when that perk is added to myHome. Must be 18 yrs or older. One offer per eligible VHI plan. Add’l terms apply. Limited-time offer. EXISTING DISNEY+, HULU OR ESPN+ SUBSCRIBERS: Perk will not automatically replace existing subscription(s). Managing subscriptions may be required to avoid multiple subscriptions and corresponding charges. Terms apply. © 2024 Disney and its related entities.
      </Body>
    </ModalBody>
    <ModalFooter buttonData={{
      primary: {
        width: '100%',
        children: 'Got it',
        onClick: () => {
          document?.getElementById('close-button').click()
        }
      }
    }}/>
  </Modal>
}

export const getNetxMaxPromoDts = dataPlan => {
  console.log('slected dataplan-------', dataPlan)
  return <Modal toggleButton={<TextLink surface="light" type='inline' size='small'>Details</TextLink>}
  id='netMax_promo_modal'>
    <ModalTitle>
      Get Netflix & Max (With Ads) Perk for 12 months, on us with the {(dataPlan || "1 Gig/2 Gig")?.replace('internet', '')?.replace('4.0','')?.replace('1 gig/2 gig','1 Gig/2 Gig')} plan. 
    </ModalTitle>
    <br></br>
    <ModalBody>
      <Body size='small' primitive='span'>
      <img src="https://ss7.vzw.com/is/image/VerizonWireless/netflix-max-home-internet-promo-overlay-2024?scl=1"></img>
      Netflix & Max (With Ads) perk requires line subscribed to an eligible Fios plan. Must be 18 years of age or older to enroll. After enrolling in the Netflix & Max (With Ads) perk, you will need to complete account setup separately for each service. Access content from each service separately. Netflix and Max may be upgraded and downgraded directly via those two services.<br />
      Enrolling in the Netflix & Max (With Ads) perk may affect existing subscriptions to Netflix and Max. After enrolling, you must register your Perk to avoid multiple subscriptions and corresponding charges. $6.98/mo perk savings based on the current $6.99/mo for Netflix Standard with Ads and $9.99/mo for Max (With Ads plan) less $10/mo perk added to Fios plan. <br />
      One offer per eligible Fios account. Subject to Netflix Terms of Use and Max Terms of Use. Max and related elements are property of Home Box Office, Inc.
      </Body>
    </ModalBody>
    <ModalFooter buttonData={{
      primary: {
        width: '100%',
        children: 'Close',
        onClick: () => {
          document?.getElementById('close-button').click()
        }
      }
    }}/>
  </Modal>
}

export const getYoutubePremiumPromoDts = (dataPlan) => {
  const prodName = (dataPlan || "1 Gig/2 Gig")?.replace?.("internet", "")?.replace?.("4.0", "")?.replace?.("1 gig/2 gig", "1 Gig/2 Gig");
  const perkProps = {
    ariaLabel: "YouTube Premium",
    elementSurface: "light",
    title: {
      children: "YouTube Premium",
      type: "title",
      underline: true,
      width: "130px",
    },
    image: {
      src: "https://ss7.vzw.com/is/content/VerizonWireless/perk-tile-youtube-premium-logo",
      alt: "YouTube Premium",
    },
    backgroundImage: {
      baseUrl: "https://ss7.vzw.com/is/image/VerizonWireless/",
      perkName: "perk-tile-youtube-premium",
      queryParams: {
        fmt: "webp",
      },
      variant: "small",
    },
  };
  return (
    <Modal
      id="youtubePremium_promo_modal"
      toggleButton={(
        <TextLink surface="light" type="inline" size="small">Details</TextLink>
      )}
    >
      <ModalTitle>
        Get YouTube Premium for 6 months, on us with the {prodName} plan.
      </ModalTitle>
      <br />
      <ModalBody>
        <div style={{ height: "fit-content" }}>
          <Perk {...perkProps} />
        </div>
        <p>
          <b>YouTube Premium On Us: </b><br />
          Offer valid thru 7.8.25. Requires an eligible Verizon Home Internet (“VHI”) plan. $10/mo perk credit ends after 6 mos or if perk is canceled or line is moved to an ineligible plan during the 6-mo promo period.
        </p>
        <p>
          After 6 mos, perk bills as $10/mo unless perk is canceled or unregistered. Must be 18 years of age or older to enroll.</p>
        <p>
          After enrolling in the YouTube Premium perk, you will need to complete account setup to use the service. Must enroll in perk w/in 60 days after purchase, or by no later than 9.6.25, whichever comes first. Enrolling in the YouTube Premium perk may affect existing subscriptions to YouTube Premium. Managing subscriptions may be required to avoid multiple subscriptions and corresponding charges. You can manage anytime in My Verizon at <a href="https://www.verizon.com" target="_blank">verizon.com</a>. If not registered with YouTube within 90 days of enrollment, perk will be removed. One offer per eligible VHI account. Subject to YouTube Terms of Service & YouTube Premium and Music Premium Terms of Use.
        </p>
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            width: "100%",
            children: "Close",
            onClick: () => {
              document?.getElementById("close-button").click()
            }
          }
        }}
      />
    </Modal>
  );
}

export const NetMaxConfirmationModal = props => {
  const { netmaxModalCTAClick, onOpenedChange, buildProduct } = props;
  const onlyNetmaxOffer = buildProduct?.sploffer?.offerplansMTM?.some(offer=>offer?.id === "R4261")
  return <Modal onOpenedChange={onOpenedChange} opened={true} id='netmax_confirmation_modal'>
    <ModalTitle>
    Do you still want 12 months of Netflix & Max (With Ads) on us?
    </ModalTitle>
    <ModalBody>
      <Body size='medium'>
        If you don’t want to add this perk today, you’ll have until {onlyNetmaxOffer ? <b>5.11.25 </b> : <b>3.2.25 </b>}to get Netflix & Max (With Ads) for 12 months on us{onlyNetmaxOffer ? "." : ", or you can pick a different special gift instead."} 
      </Body>
    </ModalBody>
    <ModalFooter children={
      <>
        <Button use='primary' width='48%' display='inline-block'
        onClick={() => netmaxModalCTAClick('keep')}>Keep this perk</Button>
        &nbsp;&nbsp;&nbsp;
        <Button use='secondary' width='48%' display='inline-block' onClick={() => netmaxModalCTAClick('later')}>Get this perk later</Button>
        {buildProduct?.sploffer?.offerplansMTM?.length > 1 && 
          (
          <div style={{ marginTop: '16px', width: '100%', textAlign: 'center'}}>
            <TextLink surface='light' type='standAlone' onClick={() => netmaxModalCTAClick('otherOffer')}>Pick a different special gift</TextLink>
          </div>
          )
        }
      </>
    }/>
  </Modal>
}

export default DiscountFlowModal;
